import { validateForm, ValidationResult } from '@/utils/validation';

import { FindingFormData } from './types';
import { validationRules } from './validation';

/**
 * Determine if a field should be validated based on its context.
 * For document findings, some fields are required that are not required for project findings.
 */
const isFieldRequired = (field: keyof FindingFormData, data: FindingFormData): boolean => {
  const rule = validationRules[field];

  if (rule.required === true) {
    return true;
  }

  if (field === 'selectedDocument' || field === 'textInDocument') {
    return data.findingType === 'DOCUMENT';
  }

  if (field === 'pageNumber') {
    return false;
  }

  if (rule.required === false) {
    return false;
  }

  return false;
};

/**
 * Validate all fields in the findings form
 */
export const validateFindingForm = (data: FindingFormData): ValidationResult<FindingFormData> => {
  return validateForm(data, validationRules, isFieldRequired);
};

export { validationRules };
